/**
 * `/settings/consent` (#373): review what you agreed to, and withdraw. The same
 * screen the gate shows before anything else, in its settings form.
 */

import { ConsentScreen } from './consent-screen.js';

export function ConsentPage(): React.JSX.Element {
  return <ConsentScreen required={false} nested />;
}
